// import moment from 'moment-timezone';
import Swiper from 'swiper';
import { Navigation, A11y, Autoplay, EffectFade } from 'swiper/modules';

let countdown_banner_interval = null;

// const convertTZ = () => {
//   return new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
// }

const countdownPosition = () => {
  if (window.theme.breakpoints.current === 'mobile') {
    $('[data-countdown-banner]').removeAttr('style');
    return;
  }

  const window_top = $(window).scrollTop();
  // const $pre_header = $('.shopify-section.preheader');
  const $header = $('.shopify-section.header .main-nav--desktop');
  // const header_top = Number($header.css('top').replace('px', ''));

  if ($('body').hasClass('sticky-header')) {
    $('[data-countdown-banner]').css('top', `${$header.outerHeight()}px`);
  } else {
    $('[data-countdown-banner]').css('top', `${$header.outerHeight() + $header.offset().top - window_top}px`);
  }
};

const endCountdown = () => {
  if (countdown_banner_interval !== null) {
    window.clearInterval(countdown_banner_interval);
  }
  
  $('[data-countdown-banner]').parent().remove();
  $('body').removeClass('has-sticky-countdown-banner');
  $('body').removeClass('has-sticky-promo-banner');
};

const startCountdown = () => {
  const date_now = moment().tz('America/Los_Angeles');
  const date_end_str = (typeof $('[data-countdown-banner]').data('countdown-banner-end') !== 'undefined') ? $('[data-countdown-banner]').data('countdown-banner-end') : '2000-01-01 00:00:00';
  const date_end_str_parts = date_end_str.split(' ');
  const date_end_str_day_parts = date_end_str_parts[0].split('-');
  const date_end_str_time_parts = date_end_str_parts[1].split(':');
  const date_end_str_day_formatted = date_end_str_day_parts.map(item => (item.length === 1) ? `0${item}` : item);
  const date_end_str_time_formatted = date_end_str_time_parts.map(item => (item.length === 1) ? `0${item}` : item);
  const date_end_formatted = `${date_end_str_day_formatted.join('-')} ${date_end_str_time_formatted.join(':')}`;
  const date_end = moment(date_end_formatted).tz('America/Los_Angeles');

  const remaining_seconds = date_end.diff(date_now, 'seconds');
  // console.log('remaining_seconds', remaining_seconds);
  // console.log(moment().seconds(remaining_seconds).format('DD:HH:mm:ss'));

  const days = Math.floor(remaining_seconds / (60 * 60 * 24));
  const hours = Math.floor((remaining_seconds % (60 * 60 * 24)) / (60 * 60));
  const minutes = Math.floor((remaining_seconds % (60 * 60)) / 60);
  const seconds = Math.floor(remaining_seconds % 60);

  // console.log(days, hours, minutes, seconds);
  // $('[data-countdown-banner] [data-countdown-banner-timer]').html(`<span>${days}</span>d : <span>${hours}</span>h : <span>${minutes}</span>m : <span>${seconds}</span>s`);

  Array.from(document.querySelectorAll('[data-countdown-banner] [data-countdown-banner-timer]')).forEach((element) => {
    element.innerHTML = `<span>${days}</span>d : <span>${hours}</span>h : <span>${minutes}</span>m : <span>${seconds}</span>s`;
  });

  if (remaining_seconds < 1) {
    endCountdown();
  }
};

// The countdown can be enabled multiple times (when slides have been defined)
const initCountdown = () => {
  if (document.querySelectorAll('[data-countdown-banner] [data-countdown-banner-timer]').length === 0) {
    return;
  }

  const countdown_banner = document.querySelector('[data-countdown-banner]');
  const date_now = moment().tz('America/Los_Angeles');

  const date_start_str = (typeof countdown_banner.dataset.countdownBannerStart !== 'undefined') ? countdown_banner.dataset.countdownBannerStart : '2000-01-01 00:00:00';
  const date_start_str_parts = date_start_str.split(' ');
  const date_start_str_day_parts = date_start_str_parts[0].split('-');
  const date_start_str_time_parts = date_start_str_parts[1].split(':');
  const date_start_str_day_formatted = date_start_str_day_parts.map(item => (item.length === 1) ? `0${item}` : item);
  const date_start_str_time_formatted = date_start_str_time_parts.map(item => (item.length === 1) ? `0${item}` : item);
  const date_start_formatted = `${date_start_str_day_formatted.join('-')} ${date_start_str_time_formatted.join(':')}`;

  const date_end_str = (typeof countdown_banner.dataset.countdownBannerEnd !== 'undefined') ? countdown_banner.dataset.countdownBannerEnd : '2000-01-01 00:00:00';
  const date_end_str_parts = date_end_str.split(' ');
  const date_end_str_day_parts = date_end_str_parts[0].split('-');
  const date_end_str_time_parts = date_end_str_parts[1].split(':');
  const date_end_str_day_formatted = date_end_str_day_parts.map(item => (item.length === 1) ? `0${item}` : item);
  const date_end_str_time_formatted = date_end_str_time_parts.map(item => (item.length === 1) ? `0${item}` : item);
  const date_end_formatted = `${date_end_str_day_formatted.join('-')} ${date_end_str_time_formatted.join(':')}`;

  // console.log('date_start_str', date_start_formatted);
  // console.log('date_end_str', date_end_formatted);

  const date_start = moment(date_start_formatted).tz('America/Los_Angeles');
  const date_end = moment(date_end_formatted).tz('America/Los_Angeles');

  // console.log('date_start', date_start);
  // console.log('date_end', date_end);

  // .format('YYYY-MM-DD HH:mm:ss');
  // console.log('date_now', date_now.format('YYYY-MM-DD HH:mm:ss'));
  // console.log('date_start', date_start.format('YYYY-MM-DD HH:mm:ss'));
  // console.log('date_end', date_end.format('YYYY-MM-DD HH:mm:ss'));

  if (date_start > date_now) {
    console.log('Countdown event hasn\'t startet yet');
    endCountdown();
    return;
  }

  if (date_end.diff(date_now, 'seconds') < 1) {
    console.log('Countdown event has ended');
    endCountdown();
    return;
  }

  countdown_banner_interval = window.setInterval(startCountdown, 1000);
};

const initCountdownSlider = () => {
  const countdown_banner = document.querySelector('[data-countdown-banner]');
  const countdown_banner_slider = countdown_banner.querySelector('[data-countdown-banner-slider]');

  if (countdown_banner.dataset.hasSlider !== 'true' || !countdown_banner_slider) {
    return;
  }

  const slider_settings = {
    modules: [ Navigation, A11y, Autoplay, EffectFade ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: true,
    slidesPerView: 1,
    slidesPerGroup: 1,
    loop: true,
    autoHeight: false,
    freeMode: false,
    navigation: {
      nextEl: '[data-countdown-banner-slider] .swiper-button-next',
      prevEl: '[data-countdown-banner-slider] .swiper-button-prev',
    },
    on: {
      // Set the current slide at the slider level to be able to update arrows color
      slideChangeTransitionStart: function (swiper) {
        // const slide = countdown_banner_slider.querySelector(`[data-pos="${swiper.realIndex}"]`);
        countdown_banner.dataset.slideCurrentSlide = swiper.realIndex + 1;
      },
    }
  };

  if (countdown_banner.dataset.sliderTransition === 'fade') {
    slider_settings.effect = 'fade';
    slider_settings.fadeEffect = {
      crossFade: true
    };
  }

  if (Number(countdown_banner.dataset.sliderAutoplay) > 0) {
    slider_settings.autoplay = {
      delay: Number(countdown_banner.dataset.sliderAutoplay) * 1000,
      pauseOnMouseEnter: true,
    };
  }

  new Swiper(countdown_banner_slider, slider_settings);
};

const initCountdownBanner = () => {
  const countdown_banner = document.querySelector('[data-countdown-banner]');

  if (!countdown_banner) {
    return;
  }

  try {
    // Used to define the filter result position
    document.querySelector('body').classList.add('has-countdown-banner');
    
    initCountdownSlider();
    initCountdown();

    if (countdown_banner.classList.contains('sticky')) {
      if ($('[data-countdown-banner]').attr('data-has-countdown') === 'true') {
        document.querySelector('body').classList.add('has-sticky-countdown-banner');
      } else {
        document.querySelector('body').classList.add('has-sticky-promo-banner');
      }
    }

    // Always visible to increase visual stability 
    // $('[data-countdown-banner]').addClass('active');

    // Entire banner click
    $(document).on('click', '[data-countdown-banner]', (e) => {
      const $item = $(e.currentTarget);

      if (typeof $item.data('countdown-banner-url') === 'undefined' || !$item.data('countdown-banner-url').length) {
        return;
      }

      window.location.href = $item.data('countdown-banner-url');
    });

    // Slide click
    $(document).on('click', '[data-countdown-banner-slider] .swiper-slide', (e) => {
      const $item = $(e.currentTarget);

      if (typeof $item.data('countdown-banner-url') === 'undefined' || !$item.data('countdown-banner-url').length) {
        return;
      }

      window.location.href = $item.data('countdown-banner-url');
    });

    // [ADA]
    $(document).on('keypress', '[data-countdown-banner]', (e) => {
      const key = e.which;
    
      // Enter / spacebar
      if (key === 13 || key === 32) {
        const $item = $(e.currentTarget);
        $item.trigger('click');
      }
    });

    $(window).on('scroll', () => {
      countdownPosition();
    });

    // Stop scrolling
    // Use higher debouce value than the one used for the header
    $(window).on('scroll', _.debounce(() => {
      countdownPosition();
    }, 500));

    // From mobile to desktop
    $(window).on('resize', _.debounce(() => {
      countdownPosition();
    }, 100));
  } catch (error) {
    // moment returns warning when initialized with undefined
  }
};

export {
  initCountdownBanner,
};

